export const LAST_ACCESSED_CHANNELS = 'LAST_ACCESSED_CHANNELS';
export const PAGE_LIMIT = 15;
